/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { BaseFiltro } from '@data/models';

@Component({
  selector: 'app-pagination-pages',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './pagination-pages.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationPagesComponent {
 /*  @Input() pageSizesSelect = signal([5, 10, 20, 50, 100]);
  @Input({ required: true }) filtros!: Signal<BaseFiltro>;
  @Input() disabled!: boolean;
  @Output() pageChange = new EventEmitter<any>();

  pageOnChange(event: any) {
    this.pageChange.emit({
      ...this.filtros(),
      start: 1,
      limit: Number.parseInt(event.target.value, 10),
    });
  } */

  readonly pageSizesSelect = input([5, 10, 20, 50, 100]);
  readonly filtros = input.required<BaseFiltro>();
  readonly disabled = input.required<boolean>();
  readonly pageChange = output<any>();

  pageOnChange(event: any) {
    this.pageChange.emit({
      ...this.filtros(),
      start: 1,
      limit: Number.parseInt(event.target.value, 10),
    });
  }
}
